import { cn } from "../../../../../src/lib/utils";
import ButtonV2 from ".";

export interface RejectButtonProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
}

export const RejectButton: React.FC<RejectButtonProps> = ({
  label,
  onClick,
  disabled,
  loading,
  className,
}) => {
  return (
    <ButtonV2
      variant="outline"
      size="md"
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      className={cn(
        "border-none bg-[#DC2626] text-white hover:text-white rounded-[8px]",
         "shadow-[0px_1px_2px_rgba(0,0,0,0.05)] transition-colors duration-150",
         "hover:bg-[color-mix(in_srgb,white_10%,#DC2626)] hover:text-white",
         "focus-visible:ring-[3px] focus-visible:ring-[#FEE2E2] focus-visible:ring-offset-0 focus-visible:outline-none",
         "active:opacity-60",
        className
      )}
    >
      {label}
    </ButtonV2>
  );
};